<template>
    <v-container grid-list-md>
        <v-layout wrap>
            <v-flex xs12 sm6>
                <ForecastingNoteList 
                    :variety="variety"
                    :notes="notes">
                </ForecastingNoteList>
            </v-flex>
            <v-flex sm1 v-if="!$vuetify.breakpoint.smAndDown">
                <v-divider vertical class="noteCenterDivider"></v-divider>
            </v-flex>
            <v-flex xs12 sm5>
                <ForecastingNoteAdd   
                    :variety="variety">
                </ForecastingNoteAdd>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

import ForecastingNoteList from "@/components/forecasting/forecastingNotes/ForecastingNoteList.vue";
import ForecastingNoteAdd from "@/components/forecasting/forecastingNotes/ForecastingNoteAdd.vue";

export default {
    components: {
        ForecastingNoteList,
        ForecastingNoteAdd
    },
    props: {
        variety: {
            type: Object,
            required: true
        },
        notes: {
            type: Array,
            required: true
        }
    },
    data(){
        return {

        };
    },
    computed: {

    },
    methods: {
    },
    created(){
        
    }
}
</script>

<style>
    .noteCenterDivider {
            left: 50%;
            position: relative;
    }
</style>